
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marketplace/template-development",
      function () {
        return require("private-next-pages/[locale]/marketplace/template-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marketplace/template-development"])
      });
    }
  